module.exports = __webpack_public_path__ + "img/kaliLogo.00655b0c.png";